export default __webpack_public_path__ + "4896d4b04430cc3dfb063d0df45e14d9.woff2";